export class RequestToAgreeTariffPeriod {
    requestToAgreeTariffPeriodId: number;
    requestToAgreeTariffId: number;
    timeFrom: string;
    timeTo: string;

    dtTimeFrom: Date;
    dtTimeTo: Date;
}